export default "__VITE_ASSET__QPmEb7Pf__"